import SectionWrap from "@/components/SectionWrap/Index";
import { UrgentWidget } from "@/components/Urgent/Index";
import { WidgetProps } from "@/types/types";
import Author from "@/ui/Author/Index";
import { Category } from "@/ui/Category/Index";
import ImageUI from "@/ui/Image/Index";
import { MoreWrap } from "@/ui/MoreWrap/Index";
import { HeroSlider } from "@/widgets/HeroSlider/Index";
import { cn } from "@pulsex/utils";
import Link from "next/link";

export const FeaturedHomeWidget = ({
  data,
  urgentNewsAside,
  isMobile,
}: WidgetProps) => {
  if (!data?.posts?.length) return;
  const isDailyEdition = data?.code.includes("daily") ? true : false;

  return (
    <SectionWrap className="home-section max-md:pt-2 md:pb-5 lg:mb-2 pt-5">
      <div className="w-full flex max-lg:flex-col">
        <div className={cn("w-full", "lg:w-[70%]")}>
          <HeroSlider
            widgetTitle={data?.title}
            data={data}
            isMobile={isMobile}
          />
        </div>

        <div
          className={cn(
            "w-full lg:mr-6 max-lg:mt-4 max-md:mt-3",
            !urgentNewsAside ? "bg-gray-100" : "max-lg:min-h-[350px]",
            "lg:w-[30%]"
          )}
        >
          {urgentNewsAside ? (
            <UrgentWidget
              urgentNewsAside={urgentNewsAside}
              isDailyEdition={isDailyEdition}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </SectionWrap>
  );
};
